<script>
import { mapActions, mapGetters } from "vuex";

import moment from "@/utils/moment";
import orderMixin from "@/mixins/orderMixin";
import eventHelper from "@/utils/helpers/event";

import PaymentHistory from "@/components/_Shared/PaymentHistory/Index";
import ProofOfPaymentWarning from "@/components/_Shared/Warnings/ProofOfPayment";

import Cancellation from "./Components/Actions/Cancellation/Index";
import OrderData from "./Data";
import ActionButton from "./_Button";

export default {
  mixins: [orderMixin],

  components: {
    OrderData,
    ActionButton,
    PaymentHistory,
    ProofOfPaymentWarning,
    Cancellation
  },

  data() {
    return {
      order: null,
      rescheduleDialogVisibility: false,
      cancellationDialogVisibility: false,
      absenceDialogVisibility: false
    };
  },

  computed: {
    ...mapGetters("orderCancellation", ["isCancellationPossible"]),
    showProofOfPaymentWarning() {
      return this.mustProvePayment(this.order);
    },
    showCancelButton() {
      return this.canCancel(this.order);
    },
    showAbsenceButton() {
      return this.orderHasDelayed(this.order);
    },
    showRescheduleButton() {
      return this.isCancellationPossible && this.canReschedule(this.order);
    },
    showRateButton() {
      return this.canRate(this.order.status);
    }
  },

  methods: {
    ...mapActions("orders", ["getOrder"]),
    ...mapActions("orderCancellation", ["reset", "setOrderObject"]),
    async setOrder() {
      try {
        this.order = await this.getOrder(this.$route.params.order_id);
      } catch (e) {}
    },

    getProfessionalName(account) {
      let name = account.first_name + "+" + account.last_name;
      return name.replace(/ /g, "+");
    },

    linkRate() {
      let baseUrl = "https://docs.google.com/forms/d/e";
      let formId = "1FAIpQLSdAkmP1MsLMZ6iskP5oHLKGEKX6vIbEJRVvazatGC8UfPhn4Q";
      let formUrl = `${baseUrl}/${formId}/viewform?usp=pp_url`;

      let orderStartsAt = moment(this.order.schedule_event.starts_at).format(
        "Y-MM-DD"
      );
      let professionalName = this.getProfessionalName(
        this.order.professional.account
      );
      let customerEmail = this.order.customer.account.email;
      let orderId = this.order.id;

      let entries = [
        `&entry.1965174137=${customerEmail}`,
        `&entry.1986052155=${orderStartsAt}`,
        `&entry.1307714351=${professionalName}`,
        `&entry.830969952=${orderId}`
      ].join("");

      return `${formUrl}${entries}`;
    }
  },

  async mounted() {
    await this.setOrder();
    await this.reset();

    this.setOrderObject(this.order);
  }
};
</script>

<template>
  <div v-if="order" >
    <div class="container">
      <Cancellation
        v-if="rescheduleDialogVisibility"
        :order="order"
        type="rescheduling"
        @close="rescheduleDialogVisibility = false"
      />

      <Cancellation
        v-if="cancellationDialogVisibility"
        :order="order"
        type="cancellation"
        @close="cancellationDialogVisibility = false"
      />

      <Cancellation
        v-if="absenceDialogVisibility"
        :order="order"
        type="absence"
        @close="absenceDialogVisibility = false"
      />

      <proof-of-payment-warning v-if="showProofOfPaymentWarning" class="p-0" />

      <base-card>
        <order-data :order="order" @show="rescheduleDialogVisibility = true" />

        <hr />

        <base-flex>
          <div class="btn bg-purple-outline"
            v-if="showRescheduleButton"
            @click="rescheduleDialogVisibility = true">
              <img class="icon" src="/static/icon_calendar.svg">REAGENDAR
          </div>
          <a
            v-if="showCancelButton"
            @click="cancellationDialogVisibility = true"
          >
            <div class="btn bg-purple-outline" > <img class="icon" src="/static/icon_cancel.svg">CANCELAR</div>
          </a>

          <a
            v-if="showAbsenceButton"
            @click="absenceDialogVisibility = true"
          >
            <div class="btn bg-purple-outline" > <img class="icon" src="/static/icon_error.svg">PROFISSIONAL FALTOU</div>
          </a>

          <a v-if="showRateButton" :href="linkRate()" target="_blank" rel="noopener noreferrer">
            <base-button size="large" outlined>avaliar limpeza</base-button>
          </a>
        </base-flex>
      </base-card>
    </div>

    <div class="container">
      <payment-history v-if="!order.cycle_id" :payments="order.payments">
        <template slot="header-right">
          <div class="btn bg-purple"
            v-if="canGoToCheckout(order)">
            <router-link
              :to="{name: 'order-checkout', params: {order_id: order.id}}">
              Efetuar pagamento
            </router-link>
          </div>
        </template>
      </payment-history>
    </div>

  </div>
</template>

<style scoped>
.bg-purple a {
  color: #ffffff;
}
.icon {
  width: 25px;
  margin-right: 10px;
}

hr {
  opacity: 0.1;
  width: 100%;
  margin-bottom: 19px;
}
.base-card {
  flex: 1;
  margin: 10px 0 10px 0;
}
.row {
  justify-content: flex-start;
}

.row button {
  margin: 0 5px;
}

.row button:first-child {
  margin-left: 0;
}
.row button:last-child {
  margin-right: 0;
}

@media (max-width: 768px) {
  .row {
    flex-direction: column !important;
  }

  .row section {
    margin: 5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Order/Index.vue